import { render, staticRenderFns } from "./TagForm.vue?vue&type=template&id=84bc1e4e"
import script from "./TagForm.vue?vue&type=script&lang=ts"
export * from "./TagForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports